function SentinelCheckOutModal($rootScope, $timeout, sentinelService) {
    return {
        redirect: 'E',
        replace: true,
        scope: {
            visit: '=?'
        },
		template: require('./check-out-modal.html'),

        link: function (scope, element) {
            scope.checkOutTime = moment();
            scope.customCheckOutSelected = false;
            scope.checkOutWarning = '';

            scope.dateOptions = {
                format: "MM/DD/YYYY HH:mm",
                showClear: false,
                showClose: true,
                showTodayButton: false,
                useCurrent: true
            };

            $timeout(function() {
                element.selectpicker();
            });

            scope.$watch(function () {
                return scope.visit;
            }, function (newVal) {
                if (newVal) {
                    sentinelService.getAccessPointsList($rootScope.selectedLog.id, scope.visit.facilityName).then(function(accessPoints) {
                        scope.availableAccessPoints = accessPoints;

                        if (scope.visit.escortIn) scope.escortOut = scope.visit.escortIn; // set default escort out to escort in.
                        if (scope.visit.doorIn && scope.availableAccessPoints.indexOf(scope.visit.doorIn) > -1) scope.selectedDoor = scope.visit.doorIn; // set default doorOut to doorIn
                        sentinelService.getSelfCheckout($rootScope.selectedLog.id, scope.visit.facilityName).then(function(selfCheckout) {
                            if (selfCheckout) scope.escortOut = "Self"; // if self check-out is enabled, set escort-out to "Self".
                        });
                    });
                }
            });

            scope.hideModal = function () {
                scope.selectedDoor = null;
                scope.escortOut = null;
                scope.customCheckOutSelected = false;
                scope.checkOutWarning = '';
                $rootScope.$broadcast('sentinel-hide-check-out-modal');
                $('#check-out-modal').modal('hide');
            };

            scope.checkOutGuest = function () {
                scope.checkOutWarning = '';

                scope.visit.doorOut = scope.selectedDoor;
                scope.visit.escortOut = scope.escortOut;
                if (scope.customCheckOutSelected) {
                    var checkOutTime = document.getElementById('checkOutTime').value;
                    var currentMillis = new Date().getTime();
                    var checkInMillis = new Date(scope.visit.checkInTime).getTime();
                    var checkOutMillis = Date.parse(checkOutTime);
                    var timeLimit = 24 * 60 * 60 * 1000;

                    if (checkOutMillis <= checkInMillis) { scope.checkOutWarning = "Check-out time can not be before check-in time"; }
                    else if (checkOutMillis - checkInMillis > timeLimit) { scope.checkOutWarning = "Check-out time can not be more than 24 hours past check-in time"; }
                    else if (checkOutMillis > currentMillis) { scope.checkOutWarning = "Check-out time can not be in the future"; }
                    else {
                        scope.visit.checkOutTime = checkOutTime;
                        sentinelService.checkOutGuest(scope.visit, scope.customCheckOutSelected);
                        this.hideModal();
                    }
                }
                else {
                    scope.visit.checkOutTime = new Date();
                    sentinelService.checkOutGuest(scope.visit, scope.customCheckOutSelected);
                    this.hideModal();
                }
            };

            scope.$watch(function () {
                return scope.visit;
            }, function (newVal) {
                if (newVal) {
                    var checkInTime = moment(scope.visit.checkInTime);
                    var now = moment();
                    var differenceSeconds = moment.duration(now.diff(checkInTime)).asSeconds();
                    if (differenceSeconds > 8 * 60 * 60 /*8 hours in seconds*/) {
                        scope.checkOutTime = checkInTime.add(8, 'hours');
                    } else {
                        scope.checkOutTime = moment();
                    }
                }
            });
        }
    }
}

angular.module('sentinel').directive('sentinelCheckOutModal', ['$rootScope', '$timeout', 'sentinelService', SentinelCheckOutModal]);